import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const getTransAnalysis = async (id) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/kyc/transAnalysis/getTransAnalysis/' + id );
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}

export const saveTransAnalysis= async (data) => {
    try {
        let response = await ServiceRequest('post', 'json', serviceHost + '/kyc/transAnalysis/saveTransAnalysis', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}
